import React, { Dispatch, SetStateAction, useRef, useState } from 'react';
import type { UploadProps } from 'antd';
import { message, Spin, Upload, } from 'antd';

import uploadImg from '../../assets/player/upload.webp'
import uploadIcon from '../../assets/uploadImg.webp'
import deleteIcon from '../../assets/deleteImg.webp'
import CryptoJS from 'crypto-js';
import './Dragger.css'
import VoiceService, { UploadPath } from '../../service/VoiceService';
import Cookies from 'js-cookie';
const { Dragger } = Upload;

// 目标组件的定义

const MyDragger = ({ setInput, tab, type, disabled = false }: any) => {
    const [isLogin, setIsLogin] = useState(!!Cookies.get('access_token'));
    const [audioUrl, setAudioUrl] = useState('');
    const [fileName, setFileName] = useState('')
    const [loading, setLoading] = useState(false)
    const taskIdRef = useRef(null)
    const md5Ref = useRef(null)
    let statusCheckTimeout;
    const headers = {
        'Authorization': 'Bearer eyJhbGciOiJSUzI1NiIsInR5cCI6IkpXVCJ9.eyJhdWQiOiJtdC1hdXRoIiwiaXNzIjoibXQiLCJzdWIiOiJtaW5nemhlIn0.hIvhNlJCHNMZG_U5g9avuRFFStPjldMKBKQcEm9Jfj12BPJJlrAf-FuamrTeDH6zJgbP_uLRHv6GMsbm7wS6j9XJP30y6_UQPwxtwwBjvXVFV4j1Cpwln1qS4G1fNJuYJOZaJjjJ3v7074EDpiTBZq7uwTiIjTPAGgRhU3srQl0'
    }

    const checkStatus = () => {
        VoiceService.get(`${UploadPath}/${taskIdRef.current}/query`, {
            headers
        }).then(res => {
            const { data } = res;
            // 如果是1000 成功了
            if (data?.status === 1000) {
                setInput(data?.text)
                setLoading(false)
                if (statusCheckTimeout) {
                    clearTimeout(statusCheckTimeout);
                }
                message.success('识别成功')
                // 如果怕不是1开头的状态
            } else if (data?.status && !/^1/.test(data.status.toString())) {
                message.error(`${data.status_text}`)
                setLoading(false)
                setFileName('')
                if (statusCheckTimeout) {
                    clearTimeout(statusCheckTimeout);
                }
            } else {
                statusCheckTimeout = setTimeout(checkStatus, 2000); // 保存定时器 ID
            }

        }).catch(err => {
            console.log(err);
        });
    };
    const props: UploadProps = {
        name: 'file',
        showUploadList: true,
        multiple: false,
        onChange(info) {
            const { status } = info.file;
            if (info.fileList.length > 1) {
                info.fileList.shift();
            }
            if (status !== 'uploading') {
                console.log('files to be upload:', info.file, info.fileList);
            }
            if (status === 'done') {
                setFileName(info.file.name)
                message.success(`${info.file.name} file uploaded successfully.`);
            } else if (status === 'error') {
                message.error(`${info.file.name} file upload failed.`);
            }
        },
        onDrop(e) {
            console.log('Dropped files', e.dataTransfer.files);
        },

        beforeUpload(file) {
            const audioType = ['PCM', 'WAV', 'OPUS', 'MP3', 'MP4', 'M4A', 'WMA', 'AAC', 'OGG', 'AMR', 'FLAC', 'SPEEX', 'AC3', 'APE', 'M4R']
            const parts = file?.name.split('.');
            const extension = parts.pop().toUpperCase();; // 获取最后一个部分
            // 在这里进行文件类型和大小的验证
            const isAudio = audioType.includes(extension)
            if (!isAudio) {
                message.error('只能上传音频文件！');
            }
            // 限制文件大小为512MB
            const isLt512M = file.size / 1024 / 1024 < 512;
            if (!isLt512M) {
                message.error('音频文件大小不能超过512MB！');
            }
            return isAudio && isLt512M;
        },

        customRequest: async ({ file, onSuccess, onError }: any) => {
            setLoading(true);
            const fileName = file.name;
            setFileName(fileName);
            setInput('');
            const CHUNK_SIZE = 10 * 1024 * 1024; // 10MB
            let uploadIndex = 0;
            const totalChunks = Math.ceil(file.size / CHUNK_SIZE);
            try {
                if (file instanceof Blob) {
                    // 1. 计算文件的MD5值
                    const reader = new FileReader();
                    reader.onloadend = async (event) => {
                        const arrayBuffer = event.target.result;
                        if (arrayBuffer instanceof ArrayBuffer) {
                            const uint8Array = new Uint8Array(arrayBuffer);
                            const wordArray = CryptoJS.lib.WordArray.create(uint8Array);
                            md5Ref.current = CryptoJS.MD5(wordArray).toString();
                            // 1. 调用 submit 仅一次
                            const submitResponse = await VoiceService.post(`${UploadPath}/submit`, {
                                "audio_type": "upload",
                                "enable_punctuation": "true",
                                "remove_disfluency": "true"
                            },
                                {
                                    headers
                                });
                            const { data: submitData } = submitResponse;
                            if (submitData.status !== 1000) {
                                setLoading(false)
                                message.error(`${submitData.status_text}`)
                            }
                            taskIdRef.current = submitData.task_id;
                            // 2. 分片上传文件
                            const uploadChunk = async (chunk: Blob, index: number) => {
                                const arrayBuffer = await chunk.arrayBuffer();
                                try {
                                    const uploadResponse = await VoiceService.post(`${UploadPath}/${taskIdRef.current}/upload`, arrayBuffer, {
                                        headers: {
                                            'Content-Type': 'application/octet-stream',
                                            ...headers
                                        }
                                    });
                                    const { data: uploadData } = uploadResponse;
                                    if (uploadData?.status === 1000) {
                                        uploadIndex++;
                                        if (uploadIndex < totalChunks) {
                                            await uploadChunk(file.slice(uploadIndex * CHUNK_SIZE, (uploadIndex + 1) * CHUNK_SIZE), uploadIndex);
                                        } else {
                                            const pyload = {
                                                task_id: taskIdRef.current,
                                                md5: md5Ref.current
                                            }
                                            VoiceService.post(`${UploadPath}/${taskIdRef.current}/uploaddone`, pyload, { headers }).then(res => {
                                                const { data } = res
                                                if (data?.status === 1000) {
                                                    checkStatus()
                                                }
                                            }).catch(err => {
                                                console.log(err)
                                            })

                                        }
                                    } else {
                                        setLoading(false)
                                        throw new Error('Upload 请求失败');
                                    }
                                } catch (err) {
                                    console.error('Upload 错误:', err);
                                    onError(err);
                                }
                            };

                            // 开始上传第一个切片
                            await uploadChunk(file.slice(0, CHUNK_SIZE), uploadIndex);
                        }
                    };
                    reader.readAsArrayBuffer(file);

                } else {
                    throw new Error('file 参数不是 Blob 类型');
                }
            } catch (error) {
                console.error('发生错误：', error);
                onError(error);
            }
        },
        onRemove(file) {
            setAudioUrl('');
        },
    };

    const tabHeight = () => {
        return tab === 'recognition' ? 476 : 406
    }
    const uploadStyle = {
        height: 93, border: 'none', background: '#E8E8E8', borderRadius: 0
    }
    const draggerStyle = {
        height: tabHeight(), border: 'none', background: '#F6F6F6', borderRadius: 0
    }
    const deleteFile = () => {
        setFileName('')
    }
    return (
        <>{fileName && !loading
            ? <div className='uploadSuccess'>
                <div className='lfet'>
                    <img src={uploadIcon} alt="" />
                    <span className='fileName'>{fileName}</span>
                </div>
                <div className='right'>
                    <span className='success'>上传成功</span>
                    <img onClick={deleteFile} style={{ cursor: 'pointer' }} src={deleteIcon} alt="" />
                </div>
            </div>
            : <><Dragger disabled={loading || !isLogin || disabled} itemRender={() => <span></span>} {...props} style={type ? uploadStyle : draggerStyle}>
                <Spin spinning={loading}>
                    <p style={{ marginBottom: 12 }} className="ant-upload-drag-icon">
                        <img src={uploadImg} alt="" />
                    </p>
                    <p style={{ fontSize: 12, color: '#222222' }} className="ant-upload-text">点击或拖拽音频到此处上传</p>
                    <p style={{ fontSize: 12 }} className="ant-upload-hint">
                        支持PCM、WAV、OPUS、MP3、M4A、WMA、AAC、OGG、AMR、FLAC、SPEEX、AC3、APE、M4R格式，文件小于 512M
                    </p>
                </Spin>
            </Dragger></>}</>

    )
};

export default MyDragger;
